document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.newsletter-popup').forEach(function (popup) {
    var storageKey = 'newsletterPopupDismissed';
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    var hideDays = parseFloat(popup.getAttribute('data-hide-days')) || 7;

    // If the form was just submitted (Shopify redirects back with this param
    // on success/error), skip the delay and show the popup immediately so
    // the visitor sees the confirmation or error message.
    var justSubmitted = window.location.search.indexOf('customer_posted=true') !== -1
      || popup.querySelector('.newsletter-popup__success')
      || popup.querySelector('.newsletter-popup__error');

    function isDismissed() {
      try {
        var stored = localStorage.getItem(storageKey);
        if (!stored) return false;
        var dismissedAt = parseInt(stored, 10);
        var hideUntil = dismissedAt + hideDays * 24 * 60 * 60 * 1000;
        return Date.now() < hideUntil;
      } catch (e) {
        return false;
      }
    }

    function markDismissed() {
      try {
        localStorage.setItem(storageKey, Date.now().toString());
      } catch (e) {
        /* localStorage unavailable, ignore */
      }
    }

    function showPopup() {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      markDismissed();
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    // Combine country dial code + phone number into the hidden field Shopify submits
    var form = popup.querySelector('.newsletter-popup__form');
    if (form) {
      form.addEventListener('submit', function () {
        var countrySelect = popup.querySelector('.newsletter-popup__country-select');
        var phoneInput = popup.querySelector('.newsletter-popup__phone-input');
        var hiddenPhone = popup.querySelector('[id^="NewsletterPopupPhoneHidden"]');

        if (phoneInput && hiddenPhone) {
          var digits = phoneInput.value.replace(/[^\d]/g, '');
          if (digits) {
            var dialCode = countrySelect ? countrySelect.value : '';
            hiddenPhone.value = dialCode + digits;
          } else {
            hiddenPhone.value = '';
          }
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        closePopup();
      }
    });

    if (justSubmitted) {
      showPopup();
    } else if (!isDismissed()) {
      setTimeout(showPopup, delay);
    }
  });
});
